"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConfigureSoldBanner = void 0;
var react_1 = require("react");
var utils_1 = require("../helpers/utils");
//TODO: Retest this logic with the changes made to the isReserveMet function
var useConfigureSoldBanner = function () {
    var _a = (0, react_1.useState)(""), bannerText = _a[0], setBannerText = _a[1];
    var _b = (0, react_1.useState)(false), showSoldBanner = _b[0], setShowSoldBanner = _b[1];
    var handleShowSoldBanner = (0, react_1.useCallback)(function (lot, liveUpdates, currentDateTimeOffset) {
        var endTime = new Date(lot === null || lot === void 0 ? void 0 : lot.endDateTimeAt);
        var reserveMet = (0, utils_1.isReserveMet)({
            reservePrice: lot === null || lot === void 0 ? void 0 : lot.reservePrice,
            overrideWinningBidAmount: lot === null || lot === void 0 ? void 0 : lot.overrideWinningBidAmount,
            winningRegisteredProfileAmount: lot === null || lot === void 0 ? void 0 : lot.winningRegisteredProfileAmount,
            topBid: liveUpdates === null || liveUpdates === void 0 ? void 0 : liveUpdates.highestBid,
        });
        if (liveUpdates === null || liveUpdates === void 0 ? void 0 : liveUpdates.extendedBy) {
            endTime.setTime(endTime.getTime() + (liveUpdates === null || liveUpdates === void 0 ? void 0 : liveUpdates.extendedBy) * 1000);
        }
        if (lot === null || lot === void 0 ? void 0 : lot.sold) {
            setBannerText("SOLD");
            setShowSoldBanner(true);
        }
        else {
            if ((lot === null || lot === void 0 ? void 0 : lot.stcStatus) === 1 && (0, utils_1.getNewDateWithOffset)(currentDateTimeOffset) > endTime && (liveUpdates === null || liveUpdates === void 0 ? void 0 : liveUpdates.highestBid)) {
                setBannerText("SOLD STC");
                setShowSoldBanner(true);
            }
            else if ((lot === null || lot === void 0 ? void 0 : lot.stcStatus) === 0 && (0, utils_1.getNewDateWithOffset)(currentDateTimeOffset) > endTime && (liveUpdates === null || liveUpdates === void 0 ? void 0 : liveUpdates.highestBid) && reserveMet) {
                setBannerText("SOLD");
                setShowSoldBanner(true);
            }
            else {
                setShowSoldBanner(false);
            }
        }
    }, []);
    return { handleShowSoldBanner: handleShowSoldBanner, bannerText: bannerText, showSoldBanner: showSoldBanner };
};
exports.useConfigureSoldBanner = useConfigureSoldBanner;
